import { render, staticRenderFns } from "./Portions.vue?vue&type=template&id=2602f124&scoped=true&"
import script from "./Portions.vue?vue&type=script&lang=js&"
export * from "./Portions.vue?vue&type=script&lang=js&"
import style0 from "./Portions.vue?vue&type=style&index=0&id=2602f124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602f124",
  null
  
)

export default component.exports